import { Node } from '@tiptap/pm/model'
import { NodeViewWrapper } from '@tiptap/react'
import React, { useEffect, useMemo, useRef } from 'react'
import { cn } from '../../../lib/utils/index.js'
import VideoPlayer from './videojs/VideoPlayer.js'
import { useGetAssetsAspectRatio } from '../../serverside/getAssetsAspectRatio.js'

interface VideoBlockViewProps {
  node: Node & {
    attrs: {
      src: string
      poster: string
      assetId: string
      playlistUrl?: string
    }
  }
  className?: string
  getVideoAspect?: () => void
}

export type Playlist = {
  id: string
  title: string
  description: string
  poster: string
  items: Item[]
}

export type Item = {
  src: string
  type: string
  label: string
  width: number
  height: number
}

export const VideoBlockViewClientsideV2 = ({
  className,
  getVideoAspect,
  ...props
}: VideoBlockViewProps) => {
  const { node } = props
  const videoWrapperRef = useRef<HTMLDivElement>(null)
  const { src, optimizedImageUrl, playlistUrl, caption, actualWidth, actualHeight, title } =
    node.attrs
  const { aspectRatio, calculateAspectRatio, isVertical } = useGetAssetsAspectRatio()

  const [error, setError] = React.useState()

  const wrapperClassName = cn(
    node.attrs.align === 'left' ? 'ml-0' : 'ml-auto',
    node.attrs.align === 'right' ? 'mr-0' : 'mr-auto',
    node.attrs.align === 'center' && 'mx-auto',
  )

  const videoJsOptions = useMemo(() => {
    return {
      sources: playlistUrl,
      poster: optimizedImageUrl,
    }
  }, [])

  useEffect(() => {
    if (!playlistUrl) {
      return
    }
    if (!aspectRatio) {
      calculateAspectRatio(
        {
          src: '',
          actualWidth: actualWidth,
          actualHeight: actualHeight,
        },
        'VIDEO',
        getVideoAspect,
      )
    }
  }, [playlistUrl])

  const style = useMemo(() => {
    if (aspectRatio) {
      return {
        aspectRatio,
        width: node.attrs.width,
      }
    }
    return {
      width: node.attrs.width,
    }
  }, [aspectRatio])
  return (
    <NodeViewWrapper className={className}>
      <div
        className={cn(wrapperClassName, 'main-videojs-wrapper aspect-square h-full')}
        {...(isVertical && { 'data-vertical': isVertical })}
        ref={videoWrapperRef}
        style={style}
      >
        {error && <div>{error}</div>}

        {playlistUrl && <VideoPlayer options={videoJsOptions} />}
      </div>
      {(caption || title) && (
        <div
          className="block mx-auto text-sm text-gray-500 text-center mt-1"
          style={{ width: node.attrs.width }}
        >
          {title || caption}
        </div>
      )}
    </NodeViewWrapper>
  )
}

export default VideoBlockViewClientsideV2
